module.exports = __webpack_public_path__ + "static/53-211a334caf208afd198829cad5d79bd1.png";